import type { DefaultSeoProps } from "next-seo";

const SEO: DefaultSeoProps = {
	defaultTitle: `Brookbush Institute - Human Movement Science`,
	titleTemplate: `%s - Brookbush Institute`,
	description: `3 Certifications, 150+ Courses, and so much more.`,
	openGraph: {
		type: `website`,
		locale: `en_US`,
		url: `https://www.brookbushinstitute.com/`,
		site_name: `Brookbush Institute`,
		images: [
			{
				url: `https://vczc4mkjnoo13s0s.public.blob.vercel-storage.com/brent-teaching.png`,
				width: 1200,
				height: 630,
				alt: `Brookbush Institute`,
			},
		],
	},
	twitter: {
		handle: `@BrookbushInst`,
		site: `@BrookbushInst`,
		cardType: `summary_large_image`,
	},
};

export default SEO;
